import { useState } from 'react';
import { Container, Title, useViewport } from '@tryhackme/thm-ui-components';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { StyledHomeContainer, StyledBanner, StyledRocketmanSvg, StyledTextContainer, StyledTextContent, StyledTextField, StyledTickIcon, StyledText, StyledTextWrapper, StyledSecondaryTextContent, StyledWavesSvg, StyledButton, StyledContainerInner, StyledContainerOuter } from 'src/features/home/home.styles';
import { SEO } from 'src/common/components';
import { Description, Videos, Community, LearnAndPractice, TwoBoxes, Brands, Cta } from 'src/features/home/components';
import { SignupModal } from '../signup/components/signup-modal';
export const Home = () => {
  const navigate = useNavigate();
  const {
    width
  } = useViewport();
  const isMobile = width < BREAKPOINTS.MOBILE;
  const [email, setEmail] = useState('');
  const [isSignupModalOpen, setIsSignupModalOpen] = useState<boolean>(false);
  const onClickSignup = () => {
    setIsSignupModalOpen(true);
  };
  const handleSignupClick = () => {
    if (isMobile) {
      navigate(`/mobile-signup?email=${email}`);
      return;
    }
    onClickSignup();
  };
  return <section data-sentry-component="Home" data-sentry-source-file="home.tsx">
      <SEO title="Learn Cyber Security | TryHackMe Cyber Training" description="TryHackMe is a free online platform to learn cyber security through hands-on labs and exercises, accessible entirely in your browser—perfect for all skill levels." hasPrefix={false} data-sentry-element="SEO" data-sentry-source-file="home.tsx" />
      <StyledBanner data-sentry-element="StyledBanner" data-sentry-source-file="home.tsx">
        <>
          <StyledContainerOuter data-sentry-element="StyledContainerOuter" data-sentry-source-file="home.tsx">
            <StyledContainerInner data-sentry-element="StyledContainerInner" data-sentry-source-file="home.tsx">
              <StyledTextContainer data-sentry-element="StyledTextContainer" data-sentry-source-file="home.tsx">
                <Title titleText={<>
                      Anyone can learn cyber security <br /> with TryHackMe
                    </>} subTitleText="Hands-on cyber security training through real-world scenarios" isLeftAlign isInBanner data-sentry-element="Title" data-sentry-source-file="home.tsx" />
                <StyledTextContent data-sentry-element="StyledTextContent" data-sentry-source-file="home.tsx">
                  <StyledTextField placeholder="Email" variant="input" type="email" value={email} onChange={e => setEmail(e.target.value)} forceDarkMode data-sentry-element="StyledTextField" data-sentry-source-file="home.tsx" />
                  <StyledButton variant="solid" color="primary" onClick={handleSignupClick} data-sentry-element="StyledButton" data-sentry-source-file="home.tsx">
                    Join for FREE
                  </StyledButton>
                </StyledTextContent>
                <StyledSecondaryTextContent data-sentry-element="StyledSecondaryTextContent" data-sentry-source-file="home.tsx">
                  <StyledTextWrapper data-sentry-element="StyledTextWrapper" data-sentry-source-file="home.tsx">
                    <StyledTickIcon icon={faCheck} data-sentry-element="StyledTickIcon" data-sentry-source-file="home.tsx" />
                    <StyledText data-sentry-element="StyledText" data-sentry-source-file="home.tsx">Beginner Friendly</StyledText>
                  </StyledTextWrapper>
                  <StyledTextWrapper data-sentry-element="StyledTextWrapper" data-sentry-source-file="home.tsx">
                    <StyledTickIcon icon={faCheck} data-sentry-element="StyledTickIcon" data-sentry-source-file="home.tsx" />
                    <StyledText data-sentry-element="StyledText" data-sentry-source-file="home.tsx">Guides and Challenges</StyledText>
                  </StyledTextWrapper>
                </StyledSecondaryTextContent>
              </StyledTextContainer>
              <StyledRocketmanSvg data-testid="rocketman-svg" data-sentry-element="StyledRocketmanSvg" data-sentry-source-file="home.tsx" />
            </StyledContainerInner>
          </StyledContainerOuter>
          <StyledWavesSvg data-testid="waves-svg" data-sentry-element="StyledWavesSvg" data-sentry-source-file="home.tsx" />
        </>
      </StyledBanner>
      <Container data-sentry-element="Container" data-sentry-source-file="home.tsx">
        <StyledHomeContainer data-sentry-element="StyledHomeContainer" data-sentry-source-file="home.tsx">
          <Description data-sentry-element="Description" data-sentry-source-file="home.tsx" />
          <LearnAndPractice data-sentry-element="LearnAndPractice" data-sentry-source-file="home.tsx" />
          <Videos data-sentry-element="Videos" data-sentry-source-file="home.tsx" />
          <Community data-sentry-element="Community" data-sentry-source-file="home.tsx" />
          <TwoBoxes data-sentry-element="TwoBoxes" data-sentry-source-file="home.tsx" />
          <Brands data-sentry-element="Brands" data-sentry-source-file="home.tsx" />
        </StyledHomeContainer>
      </Container>
      <Cta onClick={handleSignupClick} data-sentry-element="Cta" data-sentry-source-file="home.tsx" />
      <SignupModal initialEmail={email} open={isSignupModalOpen} onOpenChange={setIsSignupModalOpen} data-sentry-element="SignupModal" data-sentry-source-file="home.tsx" />
    </section>;
};